import React from "react";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { Headline } from "~/features/ui/headline";
import { IconButton } from "~/features/ui/icon-button";
import { stripHtmlTags } from "~/features/app/utils";
import ArrowRight from "~/public/icons/arrow-right.svg";

type Props = {
  headline?: string;
  count?: string;
  text?: string;
  url?: string;
  newWindow?: boolean;
  linkText?: string;
  hasPlusIcon?: boolean;
  media?: React.ReactNode;
  tagsPosition?: "body" | "media-overlay";
  tags?: React.ReactNode;
  footer?: React.ReactNode;
};

const hoverId = "showcase-card-hover";

export function ShowcaseCard(props: Props) {
  const { headline, text, url, newWindow, media, linkText, footer, count } = props;

  const content = (
    <div tw="flex flex-col flex-1 gap-lg lg:gap-xl">
      <div tw="relative">
        <div tw="absolute z-10 bottom-sm right-sm">
          <IconButton as="div" icon={{ component: ArrowRight }} hoverId={hoverId} />
        </div>
        {media}
      </div>

      <div tw="flex flex-col flex-1">
        {headline && (
          <div tw="flex items-center gap-x-16 lg:gap-x-24">
            {Boolean(count) && (
              <span tw="text-mobile-caption-20-normal lg:text-desktop-caption-20-normal font-aeonik">{count}</span>
            )}
            <Headline
              type="h2"
              tw="text-mobile-subtitle-30-normal lg:text-desktop-subtitle-30-normal"
              text={headline}
            />
          </div>
        )}
        {text && (
          <div tw="text-mobile-body-20-normal lg:text-desktop-body-20-normal mt-16">
            <p>{stripHtmlTags(text)}</p>
          </div>
        )}
        {url && Boolean(linkText) && (
          <div tw="mt-auto pt-md">
            <Button as="div" icon={ArrowRight} variant="underline" hoverId={hoverId}>
              {linkText}
            </Button>
          </div>
        )}
        {footer && <div tw="mt-auto">{footer}</div>}
      </div>
    </div>
  );

  if (url) {
    return (
      <Link id={hoverId} tw="relative flex flex-col h-full" href={url} newWindow={newWindow}>
        {content}
      </Link>
    );
  }

  return (
    <div id={hoverId} tw="relative flex flex-col h-full">
      {content}
    </div>
  );
}
